<template>
  <div>
    <div class="row align-items-center mb-ten">
      <div class="col">
        <h5>Захиалгын мэдээлэл</h5>
      </div>
      <a @click.stop="modalHandler" class="icon-btn close-btn mr-row">
        <i class="sr sr-close"></i>
      </a>
    </div>
    <table v-if="orderInfo" id="table" class="table default-table pb-1 mb-1">
      <tbody>
      <tr>
        <td class="text-right">{{ this.$t('brand.symbol.title') }}</td>
        <td class="text-left">{{ this.orderInfo.symbol }}</td>
      </tr>
      <tr>
        <td class="text-right">{{ this.$t('order.quantity') }}</td>
        <td class="text-left">{{ this.$options.filters.amount(this.orderInfo.quantity) }}
        </td>
      </tr>
      <tr v-if="this.orderInfo.order_type === 2">
        <td class="text-right">{{ this.$t('order.unit-price') }}</td>
        <td class="text-left">{{ this.$options.filters.currency(this.orderInfo.unit_price, '', '₮',) }}
        </td>
      </tr>
<!--      <tr v-else>-->
<!--        <td class="text-right"></td>-->
<!--      </tr>-->
      <tr>
        <td class="text-right">{{ this.$t('brand.type.title') }}</td>
        <td class="text-left">{{ this.orderTypeString }}</td>
      </tr>
      <tr>
        <!-- v-if="this.orderInfo.order_type === 2" -->
        <td class="text-right">{{ this.$t('order.effective-date') }}</td>
        <td class="text-left">{{ this.orderInfo.time_in_force === 9 ? this.nextWeek : this.timeInForceString }}
        </td>
      </tr>
      <tr v-if="this.orderInfo.time_in_force === 6">
        <td class="text-right">{{ this.$t('helper.date') }}</td>
        <td class="text-left">{{ this.$options.filters.formatDate(this.orderInfo.expire_time,) }}
        </td>
      </tr>
      <tr>
        <td class="text-right">{{ this.$t('order.order_amount') }}</td>
        <td class="text-left">{{ this.orderInfo.order_type === 1 ? '&asymp;' : '' }} {{ this.$options.filters.currency(this.orderInfo.order_amount, '', '₮',) }}
        </td>
      </tr>
      <tr>
        <td class="text-right">{{ this.$t('order.fee') }}</td>
        <td class="text-left">{{ this.orderInfo.order_type === 1 ? '&asymp;' : '' }} {{ this.$options.filters.currency((this.orderInfo.commission ?? this.feeAmount), '', '₮',) }}
        </td>
      </tr>
      </tbody>
    </table>
    <tax-info v-if="this.buySellType === 'sell' && taxInfo !== null" class="mb-2" :amount="taxInfo" :msg="taxMessage"></tax-info>
    <table v-if="orderInfo" class="table total-table default-table">
      <tbody>
      <tr>
        <td class="text-right border-0" style="width: 50%;">{{ this.$t('order.total-amount') }}</td>
        <td class="text-left border-0" style="width: 50%;">{{ this.orderInfo.order_type === 1 ? '&asymp;' : '' }} {{ this.$options.filters.currency(this.totalAmount, '', '₮',) }}
        </td>
      </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-center">
      <ic-button class="mr-ten" :color="this.buySellType === 'sell' ? 'danger' : ''" @click="sendRequest">
        {{ this.buySellType === 'buy' ? this.$t('order.buy') : this.$t('order.sell') }}
      </ic-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'
import api from "../../api/tax";
import WarningInfo from "../WarningInfo.vue";
import TaxInfo from "../TaxInfo.vue";

export default {
  components: {
    WarningInfo,
    TaxInfo,
  },
  props: {
    orderInfo: {
      type: Object,
      required: true,
    },
    buySellType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tax: 0,
      feeAmount: 0,
      taxMessage: '',
      orderTypeOption: [
        {value: 1, text: this.$t('brand.type.current')},
        {value: 2, text: this.$t('brand.type.conditional')},
      ],
      durationOption: [
        {value: 0, text: this.$t('order.duration.today')},
        {value: 9, text: this.$t('order.duration.this-week')},
        {value: 6, text: this.$t('helper.date')},
      ],
    }
  },
  mounted() {
    this.getTax();
    // this.getFee();
  },
  methods: {
    modalHandler() {
      this.$emit('closeModal')
    },
    sendRequest() {
      this.$emit('sendRequest', this.orderInfo.commission)
    },
    async getTax() {
      this.isLoading = true
      try {
        const {data} = await api.getTax({
          symbol: this.orderInfo.symbol,
          unit_price: this.orderInfo.unit_price,
          quantity: this.orderInfo.quantity,
        })
        if(data.success === true) {
          this.tax = data.value
          this.taxMessage = data.description
        }
      } catch (e) {
        console.error(e)
      }
      this.isLoading = false
    },

    async getFee() {
      this.isLoading = true
      try {
        const {data} = await api.getFee({...this.orderInfo, 'side' : (this.buySellType === 'buy' ? 1 : 2)})
        this.feeAmount = data
        this.$emit('setCommission', this.feeAmount)
      } catch (e) {
        console.error(e)
      }
      this.isLoading = false
    },
  },
  computed: {
    nextWeek() {
      // TODO: tsag xaruulax shaardlagatai bol tsagiig format value deer nemj ugno HH:MM:ss
      return moment().add(7, 'days').format('YYYY-MM-DD')
    },
    orderTypeString() {
      if (this.orderInfo) {
        return this.orderTypeOption.find(
            (x) => x.value === this.orderInfo.order_type,
        ).text
      }
    },
    timeInForceString() {
      if (this.orderInfo) {
        return this.durationOption.find(
            (x) => x.value === this.orderInfo.time_in_force,
        ).text
      }
    },
    totalAmount() {
      if (this.orderInfo) {
        if (this.buySellType === 'buy')
          return this.orderInfo.order_amount + (this.orderInfo.commission ?? this.feeAmount)
        if(this.tax > 0)
          return this.orderInfo.order_amount - (this.orderInfo.commission ?? this.feeAmount) - this.tax
        return this.orderInfo.order_amount - (this.orderInfo.commission ?? this.feeAmount)
      }
    },
    taxInfo() {
      if(this.tax > 0)
        return this.$options.filters.currency(this.tax, '', '₮',)
      return null;
    },
  },
}
</script>